import { get, set } from 'lodash/fp'
import { compose } from 'redux'
import { forIn, differenceBy, map } from 'lodash'
import { setOnSuccess } from 'lp-redux-api'
import { createSelector } from 'reselect'
/**
 * Shared handler for the updateParticipantsWithMappedAgreement action.
 * Stamps agreement identifiers onto each participant based on the plan mapping hash.
 *
 * @param {Function} getExtraFields - Receives the matched servicesAgreement and returns
 *   additional fields to spread onto each participant. Defaults to an empty object.
 */
export function buildUpdateParticipantsWithMappedAgreementHandler(
  getExtraFields = () => ({})
) {
  return (state, action) => {
    const completedServicesAgreements =
      get('completedServicesAgreements', state) || []

    let participantsForSubmission = []
    forIn(action.payload, ({ servicesAgreement: id, participants }) => {
      const mappedServicesAgreement = completedServicesAgreements.find(
        (agreement) => agreement.serviceAgreementID === id
      )
      if (!mappedServicesAgreement) return
      const participantsWithServicesAgreement = participants.map(
        (participant) => ({
          ...participant,
          mappedPlanName: mappedServicesAgreement.name,
          serviceAgreementID: mappedServicesAgreement.serviceAgreementID,
          agreementID: mappedServicesAgreement.agreementID,
          ...getExtraFields(mappedServicesAgreement),
        })
      )
      participantsForSubmission.push(...participantsWithServicesAgreement)
    })

    const discardedParticipants = get('discardedParticipants', state) || []

    return compose(
      set('participantsForSubmission', participantsForSubmission),
      set(
        'discardedParticipants',
        differenceBy(discardedParticipants, participantsForSubmission, 'row')
      )
    )(state)
  }
}
export const planMatchResultsInitialState = {
  planMatchResults: [],
}
export const resetPlanMatchResults = set('planMatchResults', [])
export const buildPlanMatchResultsActionHandlers = (apiActions) => ({
  [apiActions.fetchPlanMatches]: setOnSuccess('planMatchResults'),
})
export const buildTransformedAudienceSelector = (
  sourceSelector,
  companyKey,
  contactKey,
  audienceType
) =>
  createSelector([sourceSelector], (items) => {
    if (!items) return
    return map(items, (item) => ({
      company: {
        ...item[companyKey],
        type: audienceType,
      },
      contact: item[contactKey],
    }))
  })
